var Actions;
(function (Actions) {
    Actions["GET_DEPARTMENT_LIST"] = "getDepartmentList";
    Actions["GET_DEPARTMENT_LIST_ALLDATA"] = "getDepartmentListAllData";
    Actions["UPDATE_DEPARTMENT_PAGE_FILTER"] = "updateDepartmentPageFilter";
    Actions["UPDATE_DEPARTMENT_SIZE"] = "updateDepartmentSize";
    Actions["UPDATE_DEPARTMENT_CODE"] = "updateDepartmentCode";
    Actions["UPDATE_DEPARTMENT_DESC"] = "updateDepartmentDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    // Department for menu mapping project
    Mutations["SET_DEPARTMENT_LOAD"] = "setDepartmentWasFirstLoad";
    Mutations["SET_DEPARTMENT_LIST"] = "setDepartmentList";
    Mutations["SET_DEPARTMENT_HANDLE_PAGE"] = "setDepartmentHandlePage";
    Mutations["SET_DEPARTMENT_PAGE"] = "setDepartmentPage";
    Mutations["SET_DEPARTMENT_LOAD_PAGE"] = "setDepartmentLoadPage";
    Mutations["SET_DEPARTMENT_LOADING"] = "setDepartmentLoading";
    Mutations["SET_DEPARTMENT_STATUS"] = "setDepartmentStatus";
    Mutations["SET_SELECTED_DEPARTMENT_NAME"] = "setSelectedDepartmentName";
    Mutations["SET_DROPDOWNLIST_DEPARTMENT_CODE"] = "setDropdownlistDepartmentCode";
    Mutations["SET_DROPDOWNLIST_DEPARTMENT_NAME"] = "setDropdownlistDepartmentName";
    Mutations["SET_DEPARTMENT_SIZE"] = "setDepartmentSize";
    Mutations["SET_DEPARTMENT_HANDLE_SIZE"] = "setDepartmentHandleSize";
    Mutations["SET_DEPARTMENT_PAGE_FILTER"] = "setDepartmentPageFilter";
    Mutations["SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER"] = "setDepartmentWasLoadQuickFilter";
    Mutations["SET_DEPARTMENT_DESC"] = "setDepartmentSelectedDesc";
    Mutations["SET_DEPARTMENT_SEARCH_BY"] = "setDepartmentSelectedSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
